import {
    GET_DASHBOARD_CONTENT_SUCCESS,
    GET_DASHBOARD_CONTENT_FAILURE,
    GET_SIMON_DATA_SUCCESS,
    GET_SIMON_DATA_FAILURE,
    GET_OFFER_DETAILS_SUCCESS,
    AEM_TRIP_LEADS_REGION_NAMES,
    PLAN_TRIPS_DATA_FAILURE,
    PLAN_TRIPS_DATA_SUCCESS,
    GET_DREAM_COMPONENT_CONTENT,
    UPCOMING_TRIPS_FAILURE,
    UPCOMING_TRIPS_SUCCESS,
    ARN_CITY_DATA_FAILURE,
    ARN_CITY_DATA_SUCCESS,
    ASPOTCONFIG,
} from './DashboardConstant';

const initialState = {
    DashboardAEMContent: null,
    DashboardAEMContentError: null,
    simonData: null,
    simonDataError: null,
    offerDetails: null,
    regionData: null,
    planTripsData: null,
    planTripsDataError: null,
    dreamComponentContent: null,
    upcomingTripsData: null,
    upcomingTripsError: null,
    arnCityData: null,
    arnCityError: null,
    aSpotConfig: null,
};
const DashboardAEMReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_DASHBOARD_CONTENT_SUCCESS:
            return {
                ...state,
                DashboardAEMContent: { ...action.payload }
            }
        case GET_DASHBOARD_CONTENT_FAILURE:
            return {
                ...state,
                DashboardAEMContentError: { ...action.payload }
            }
        case GET_SIMON_DATA_SUCCESS:
            return {
                ...state,
                simonData: { ...action.payload },
                simonDataError: false,
            }
        case GET_SIMON_DATA_FAILURE:
            return {
                ...state,
                simonDataError: true,
            }
        case GET_OFFER_DETAILS_SUCCESS:
            return {
                ...state,
                offerDetails: { ...action.payload }
            }
        case AEM_TRIP_LEADS_REGION_NAMES:
            return {
                ...state,
                regionData: { ...action.payload }
            }
        case PLAN_TRIPS_DATA_FAILURE:
            return {
                ...state,
                planTripsDataError: true,
            }
        case PLAN_TRIPS_DATA_SUCCESS:
            return {
                ...state,
                planTripsDataError: false,
                planTripsData: action.payload,
            }
        case GET_DREAM_COMPONENT_CONTENT:
            return {
                ...state,
                dreamComponentContent: { ...action.payload },
            }
        case UPCOMING_TRIPS_SUCCESS:
            return {
                ...state,
                upcomingTripsData: { ...action.payload },
                upcomingTripsError: false,
            }
        case UPCOMING_TRIPS_FAILURE:
            return {
                ...state,
                upcomingTripsError: true,
            }
        case ARN_CITY_DATA_SUCCESS:
            return {
                ...state,
                arnCityData: [ ...action.payload ],
                arnCityError: false,
            }
        case ARN_CITY_DATA_FAILURE:
            return {
                ...state,
                arnCityError: true,
            }
        case ASPOTCONFIG:
            return {
                ...state,
                aSpotConfig: action.payload,
            }
        default:
            return {
                ...state
            }
    }
}
export default DashboardAEMReducer;